import React, { useState, useRef, useContext, useEffect } from "react";
import { Text, TextInput, View, StyleSheet, FlatList, TouchableOpacity, useWindowDimensions, Platform } from "react-native";

import CategoryElement from "../components/CategoryElement";
import CartElement from "../components/CartElement";
import { CategoriesContext } from "../context/CategoriesContext";
import { CartContext } from "../context/CartContext";

import Config from "../config/Config";

const config = new Config();

const TEST_VERSION = false;
const CATEGORIES_TITLE = "Nossas Especialidades";

const WIDTH_TRESHOLD = 640;
const CATEGORY_SPACE = 120;

const CategoriesScreen = ({ route, navigation }) => {
  const [title, setTitle] = useState(CATEGORIES_TITLE);
  const scannerField = useRef("");
  const [scannerData, setScannerData] = useState("");
  const { cart, emptyCart, clearCart, keepCart, setKeepCart } = useContext(CartContext);
  const { categories, previousCategories, setCategories, popCategories, getChildCategories } = useContext(CategoriesContext);
  const { width, height } = useWindowDimensions();

  const { navigationAction, order } = route.params;

  useEffect(() => {
    const unsubscribe = navigation.addListener('beforeRemove', (e) => {
      while (previousCategories.length > 0) {
        popCategories();
      }
      if (config.BUILD_PRODUCT === config.PEDSEGURO_INDOOR) {
        // Prevent default behavior of leaving the screen
        e.preventDefault();
      } else {
        navigation.dispatch(e.data.action);
      }
    });
    if (!keepCart) {
      clearCart();
    }
    return unsubscribe;
  }, []);

  const selectedCategory = (id, name) => {
    // setCurrentParent(id);
    // const childCategories = getCategories(id, allCategories);
    const childCategories = getChildCategories(id);
    if (childCategories.length > 0) {
      setTitle(name);
      setCategories(childCategories);
    } else {
      setKeepCart(true);
      navigation.navigate("Products", { id: id, title: name, navigationAction: navigationAction, order: order });      
    }
  }

  // Portrait proportion (section1/section2): 9/5 (14)
  // Landscape proportion (section1/section2): 4/3 (7)
  const portrait = (width < WIDTH_TRESHOLD);
  const section1Height = Math.trunc(portrait ? height * 9/14 : height);
  const section2Height = portrait ? height - section1Height : height - 60;

  return (
    <View style={portrait ? styles.verticalLayout : styles.horizontalLayout}>
      <View style={{flex: portrait ? 9 : 4}}>
        <Text style={styles.categoriesTitle}>{title}</Text>
        <FlatList
          LisHeaderComponent={<Text></Text>}
          ListFooterComponent={<Text></Text>}
          contentContainerStyle={styles.listStyle}
          numColumns={Math.trunc(portrait ? width / CATEGORY_SPACE : width * 4/7 / CATEGORY_SPACE)}
          data={categories}
          keyExtractor={category => category.name}
          renderItem={({ item }) => {
            return (
              <View style={styles.categoryItem}>
                <TouchableOpacity onPress={() => { selectedCategory(item.id, item.name) }}>
                  <CategoryElement item={item} />
                </TouchableOpacity>
              </View>
            );
          }}
        />
      </View>
      <View style={{ flex: portrait ? 5 : 3, justifyContent: 'flex-start', backgroundColor: config.SECTION2_COLOR }}>
        <CartElement action={'create'} maxHeight={section2Height - 90} hideTitle={portrait}/>
        <View>
          {!emptyCart() &&
            <View>
              <TouchableOpacity style={styles.buttons} onPress={() => {
                if (navigationAction === 'EDIT_ORDER') {
                  navigation.navigate("OrderDetails", { order: order, navigationAction: navigationAction });
                } else {
                  navigation.navigate("Checkout", {cart: cart});
                }
              }}>
                <Text style={styles.buttonText}>Finalizar</Text>
              </TouchableOpacity>
            </View>
          }
          {(Platform.OS == 'android' && TEST_VERSION) &&
            <View>
              <TextInput
                style={styles.textInput}
                ref={scannerField}
                onSubmitEditing={() => {}}  
                blurOnSubmit={false}
                onChangeText={(text) => {
                  console.log(text);
                  setScannerData("");
                }}
                value={scannerData}
              />
              <TouchableOpacity style={styles.buttons} onPress={() => scannerField.current.focus()}>
                <Text style={styles.buttonText}>Ativar Scanner</Text>
              </TouchableOpacity>
            </View>
          }
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  verticalLayout: {
    flexDirection: "column",
    flex: 1
  },
  horizontalLayout: {
    flexDirection: "row",
    justifyContent: 'center',
    flex: 1
  },
  listStyle: {
    margin: 5,
  },
  categoriesTitle: {
    fontSize: 30,
    fontWeight: 'bold',
    marginLeft: 10,
    marginTop: 5
  },
  textInput: {
    margin: 10
  },
  categoryItem: {
    marginBottom: 10
  },
  buttons: {
    backgroundColor: '#965E11',
    width: 150,
    marginVertical: 10,
    paddingVertical: 10,
    borderRadius: 10,
    alignSelf: 'center'
  },
  buttonText: {
    fontSize: 17,
    fontWeight: 'bold',
    alignSelf: 'center',
    color: 'white'
  },
});

export default CategoriesScreen;